import { FC } from 'react';
import { useLocation } from 'react-router';
import { Center } from '@chakra-ui/react';

import useCompanyContext from 'common/hooks/useCompanyContext';
import { useCompanyProfile } from 'common/hooks/useCompanyProfile';
import SunshineLoader from 'components/_core/SunshineLoader';

import { useSelectedTaxForecast } from '../../hooks/useSelectedTaxForecastPeriod';
import { useTaxForecastData } from '../../hooks/useTaxForecastData';
import MicroEstimationFlow from './components/MicroEstimationFlow';

export const ESTIMATION_TAX_FORECAST_PERIOD_ID = 'taxForecastPeriodId';

const MicroEstimation: FC = () => {
  const [selectedTaxForecastPeriod, setSelectedTaxForecast] =
    useSelectedTaxForecast();
  const { companyProfileId } = useCompanyContext();
  const location = useLocation();
  const { company, loading: companyLoading } =
    useCompanyProfile(companyProfileId);
  const queryParams = new URLSearchParams(location.search);
  const taxForecastPeriodId = queryParams.get(
    ESTIMATION_TAX_FORECAST_PERIOD_ID,
  );

  const {
    currentTaxForecastPeriod,
    loading: taxForecastDataLoading,
    taxForecastPeriods,
    taxForecastProfile,
  } = useTaxForecastData({
    onCompleted: (data) => {
      if (data.viewer.company.taxForecastPeriods && taxForecastPeriodId) {
        const taxForecastPeriod = taxForecastPeriods.find(
          (period) => period.taxForecastPeriodId === taxForecastPeriodId,
        );
        if (taxForecastPeriod) {
          setSelectedTaxForecast(taxForecastPeriod);
        } else if (currentTaxForecastPeriod) {
          // Default the selected period to the current one if none is found
          setSelectedTaxForecast(currentTaxForecastPeriod);
        }
      }
    },
  });

  // If taxForecastPeriodId query param is found, we should wait that the context's selectedTaxForecast is updated
  if (
    companyLoading ||
    taxForecastDataLoading ||
    (taxForecastPeriodId && !selectedTaxForecastPeriod)
  ) {
    return (
      <Center height="full">
        <SunshineLoader />
      </Center>
    );
  }

  //todo: CAC-244 Implement error screen
  if (!company) {
    return null;
  }

  return (
    <MicroEstimationFlow
      companyProfile={company}
      taxForecastPeriod={selectedTaxForecastPeriod ?? currentTaxForecastPeriod}
      taxForecastProfile={taxForecastProfile ?? undefined}
    />
  );
};

export default MicroEstimation;
